import axios, { AxiosInstance } from 'axios';
import { registerReqInterceptors } from './interceptors/request-interceptor';
import { registerResponseInterceptors } from './interceptors/response-interceptor';

const sponsorAxiosInstance: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SPONSOR_BASE_URI,
  headers: {
    'Content-Type': 'application/json',
  },
});

registerReqInterceptors();

registerResponseInterceptors();

export { sponsorAxiosInstance };
